import { useEffect, useState } from "react";
import { FactorActivityData, FactorActivityUpdate } from "../types";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import { Column, Row, ScrollRow } from "../../../containers";
import { AlignItems, JustifyContent } from "../../../containers/types";
import { PopupBack, PopupClose } from "../../../../popup";
import { Heading } from "../../../typography";
import { BackContainer, Cheque, Vec2 } from "../../../../types";
import { ChequeApi, FactorApi } from "../../../../api";
import { LilCheque } from "../../../cheque";
import { TextInput } from "../../../inputs";
import { addComma } from "../../../../utils";
import OptionList from "../../../optionlist";
import { LogoutIcon } from "../../../../assets/icons";
import { FactorDetails } from "../../../factor";

const FactorUpdateActivityPopup = <T extends {}>(
  props: BackContainer<FactorActivityData, T>
) => {
  const activity = props.data as FactorActivityUpdate;
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const theme = useThemeStore((s) => s.theme);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "auto",
        maxWidth: 816,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [cheques, setCheques] = useState<Array<Cheque>>([]);

  useEffect(() => {
    activity.cheques.forEach((c) => {
      ChequeApi.getById(c.$oid)
        .then((_res) => {
          setCheques((prev) => [...prev, _res]);
        })
        .catch((err) => {
          pushAlert(err.msg || "unknown error", "error");
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [mousePos, setMousePos] = useState<Vec2>({ x: 0, y: 0 });

  const onRightClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    e.preventDefault();
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <Column
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Start}
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
      props={{ onContextMenu: onRightClick }}
    >
      <PopupClose />
      {props.back ? (
        <PopupBack Component={props.back.component} props={props.back.props} />
      ) : (
        <></>
      )}

      <OptionList
        mousePos={mousePos}
        options={[
          {
            title: "برو به فاکتور",
            Icon: LogoutIcon,
            onClick: () => {
              FactorApi.getById(activity.factor.$oid)
                .then((factor) => {
                  setPopupBody(
                    <FactorDetails<BackContainer<FactorActivityData, T>>
                      factor={factor}
                      back={{ component: FactorUpdateActivityPopup, props }}
                    />
                  );
                })
                .catch((err) => pushAlert(err.msg || "unknown error", "error"));
            },
          },
        ]}
      />

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        ویرایش فاکتور
      </Heading>

      <Row style={{ width: "90%" }} gap={20} className="factor-activity-row">
        <TextInput
          label="مشتری"
          value={getCustomerById(activity.customer.$oid)?.fullname || ""}
          inputProps={{ readOnly: true }}
        />

        <TextInput
          label="بابت"
          value={activity.description}
          inputProps={{ readOnly: true }}
        />

        <TextInput
          label="مبلغ کل"
          value={addComma(activity.total_price)}
          inputProps={{ readOnly: true }}
        />
      </Row>

      <Heading
        textStyles={{ width: "90%", textAlign: "right" }}
        color={theme.textOnOverlay}
      >
        چک ها
      </Heading>
      <Row style={{ width: "90%" }}>
        <ScrollRow gap={10} height={200}>
          {cheques.map((c) => (
            <LilCheque<BackContainer<FactorActivityData, T>>
              key={c._id.$oid}
              {...c}
              background={theme.background}
              back={{ component: FactorUpdateActivityPopup, props }}
            />
          ))}
        </ScrollRow>
      </Row>
    </Column>
  );
};

export default FactorUpdateActivityPopup;
